import { defineStore } from 'pinia'
import type { AdminProfile } from '~/types/admin'

export const useAdminStore = defineStore('admin', {
  state: () => ({
    hydrated: false,
    isAuthenticated: false,
    admin: null as AdminProfile | null,
  }),

  getters: {
    isOwner: (state) => state.admin?.role === 'owner',
    isSupport: (state) => state.admin?.role === 'support',
    canManageStaff: (state) => state.admin?.role === 'owner' || state.admin?.role === 'admin',
  },

  actions: {
    reset() {
      this.isAuthenticated = false
      this.admin = null
    },

    applyMe(admin: AdminProfile) {
      this.admin = admin
      this.isAuthenticated = true
    },

    async hydrate() {
      try {
        const me = await $fetch<{ admin: AdminProfile }>('/api/admin/me')
        this.applyMe(me.admin)
      } catch {
        this.reset()
      }
      this.hydrated = true
    },

    async logout() {
      try {
        await $fetch('/api/admin/auth/logout', { method: 'POST' })
      } catch {
        // already gone
      }
      this.reset()
      this.hydrated = true
    },
  },
})
